import PageBaseButton from './PageBaseButton';

interface AddButtonProps {
  onClick: () => void;
  buttonLabel: string;
}

const AddButton = ({ onClick, buttonLabel }: AddButtonProps) => {
  return (
    <PageBaseButton
      onClick={onClick}
      variant="add-custom"
      buttonText={`${buttonLabel}を追加`}
    />
  );
};

export default AddButton;
